import hkdf from "@panva/hkdf";
import { CompactEncrypt, EncryptJWT, compactDecrypt, jwtDecrypt } from "jose";
const ENC = 'A256GCM';
const ALG = 'dir';
const DIGEST = 'sha256';
const BYTE_LENGTH = 32;
const ENCRYPTION_INFO = 'JWE CEK';
async function encryptJWT(payload, secret, additionalHeaders) {
    const encryptionSecret = await hkdf(DIGEST, secret, '', ENCRYPTION_INFO, BYTE_LENGTH);
    const encryptedCookie = await new EncryptJWT(payload).setProtectedHeader({
        enc: ENC,
        alg: ALG,
        ...additionalHeaders
    }).encrypt(encryptionSecret);
    return encryptedCookie.toString();
}
async function decryptJWT(cookieValue, secret) {
    const encryptionSecret = await hkdf(DIGEST, secret, '', ENCRYPTION_INFO, BYTE_LENGTH);
    const cookie = await jwtDecrypt(cookieValue, encryptionSecret, {});
    return cookie;
}
async function encryptPlainText(payload, secret, additionalHeaders) {
    const encryptionSecret = await hkdf(DIGEST, secret, '', ENCRYPTION_INFO, BYTE_LENGTH);
    const encryptedCookie = await new CompactEncrypt(new TextEncoder().encode(payload)).setProtectedHeader({
        enc: ENC,
        alg: ALG,
        ...additionalHeaders
    }).encrypt(encryptionSecret);
    return encryptedCookie.toString();
}
async function decryptPlainText(cookieValue, secret) {
    const encryptionSecret = await hkdf(DIGEST, secret, '', ENCRYPTION_INFO, BYTE_LENGTH);
    const cookie = await compactDecrypt(cookieValue, encryptionSecret, {});
    return cookie;
}
export { decryptJWT, decryptPlainText, encryptJWT, encryptPlainText };
